/* eslint-disable */
import {
  Flex,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  Button,
  Select,
  HStack,
  VStack,
  Box,
  Stack,
  Badge,
} from "@chakra-ui/react";
import { Card, CardHeader, CardBody, CardFooter } from "@chakra-ui/react";
// Custom components
import { StarBorderOutlined, Star } from "@mui/icons-material";
import { Grid, GridItem, SimpleGrid } from "@chakra-ui/react";
// import Card from "components/card/Card";
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  usePagination,
  useSortBy,
  useTable,
  useFilters,
  useAsyncDebounce,
} from "react-table";
import moment from "moment";
import { downloadExcel } from "react-export-table-to-excel";
import {
  convertDateToLocal,
  isNotEmptyData,
  convertCallDurationToMin,
  convertCallDurationToMinExcel
} from "../../../../utils/Utils";
import {
  MdPlayArrow,
  MdDownload,
  MdEdit,
  MdPhone,
  MdLockClock,
} from "react-icons/md";
import CommonModal from "components/modal/CommonModal";
import Window from "floating-window-ui";
import { wfNameAndIdmapping } from "../variables/columnsData";
import {
  downloadAudioFileFromBlob,
  getAnalyticsApiData,
  processWAVfilreApi,
  triggerAnalyticsRefreshApi,
  makeCallResolvedApi,
} from "../../../../redux/agent";
import { useSelector, useDispatch } from "react-redux";
import { setLoader } from "../../../../redux/actions/loader";
export default function ZetScenarioId32Table(props) {
  const { title, columnsData, tableData, isEvening, updateAnalyticsValue } =
    props;
  const dispatch = useDispatch();
  const columns = useMemo(() => columnsData, [columnsData]);
  const tb = useMemo(() => tableData, [tableData]);
  const [data, setData] = useState([]);
  const [allDataWithoutFilter, setAllDataWithoutFilter] = useState([]);
  const [paginationPageValue, setPaginationPageValue] = useState(0);
  const [highlightEditingRow, setHighlightEditingRow] = useState(null);
  const [openCallSummaryInformationModal, setOpenCallSummaryInformationModal] =
    useState(false);
  const UTC_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";
  const convertToString = (data) => {
    if (data !== null && data !== undefined) {
      return data.toString();
    } else {
      ("");
    }
  };
  const getDisposition = (data) => {
    // console.log("Disposition data", data);
    let disposotionstring = "";
    if (data && data.length) {
      // for (let i = 0; i < data.length; i++) {
      //   disposotionstring = disposotionstring + data[i];
      // }
      disposotionstring = data[data.length - 1];
      return disposotionstring;
    } else {
      return disposotionstring;
    }
  };
  const maskPhoneNo = (number) => {
    if (number) {
      let noString = number.toString();
      let newNo = "XXXX" + noString.substring(4, noString.length);
      return newNo;
    } else {
      return "";
    }
  };

  const checkCallBackType = (data) => {
    if (data && data?.callback_requested === true) {
      if (data && data.call_back_requested_by === "user") {
        return "User Request";
      } else {
        return "Bot callback";
      }
    } else {
      return "";
    }
  };
  const checkCallInfo = (data) => {
    if (data && data?.issue_resolved === true) {
      return "Issue Resolved";
    } else if (data && data?.callback_requested === true) {
      if (data && data?.call_back_requested_by === "agent") {
        return "Callback By Agent";
      } else {
        return "Callback By User";
      }
    } else if (data && data?.call_not_completed === true) {
      return "Call Not Completed";
    } else {
      return "Not Resolved";
    }
  };
  // console.log("Table data", tableData);
  useEffect(() => {
    const modifiedDataArray = tableData?.results?.map((dataObject) => {
      let myDate = convertDateToLocal(dataObject.call_start_time);
      const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      let callDuration = convertCallDurationToMin(dataObject.callDuration);
      let callAnanlytics = dataObject?.callAnanlytics;
      // console.log("callAnanlytics?.apply_card",convertToString(callAnanlytics.apply_card))
      //convert non string data to string using convertToString() Function
      let modifiedData = {
        phoneNumber: dataObject.userId,
        callType: convertToString(callAnanlytics?.call_type) || "inbound",
        sessionId: dataObject.sessionId,
        customerQueries: convertToString(
          callAnanlytics?.list_of_customer_queries,
        ),
        callInfo: checkCallInfo(callAnanlytics),
        issueResolved: convertToString(
          callAnanlytics?.issue_resolved
            ? callAnanlytics?.issue_resolved
            : false,
        ),
        summary: dataObject.summary,
        // registered_number: convertToString(dataObject.userId),
        customerName: callAnanlytics?.customer_name,
        productName: callAnanlytics?.product_name,
        language: convertToString(callAnanlytics?.language),
        bankName: convertToString(callAnanlytics?.bank_name),
        agentName: convertToString(callAnanlytics?.agent_name),
        applyingCard: convertToString(callAnanlytics?.apply_card),
        sendSms: convertToString(callAnanlytics?.send_sms),
        call_transfer: convertToString(callAnanlytics?.callback_requested),
        callAbandoned: convertToString(dataObject?.call_abandoned),
        csatRating:convertToString(callAnanlytics?.feedback_rating),
        callNotComplete: convertToString(callAnanlytics?.call_not_completed),
        conversationCompleted: convertToString(
          !callAnanlytics?.call_not_completed,
        ),
        l1SubQuery: convertToString(callAnanlytics?.L1_sub_query),
        l2SubQuery: convertToString(callAnanlytics?.L2_sub_query),
        l3SubQuery: convertToString(callAnanlytics?.L3_sub_query),
        callBackArrangedBy: convertToString(
          callAnanlytics?.call_back_requested_by,
        ),
        callBackType: checkCallBackType(callAnanlytics),
        paymentDate: convertToString(callAnanlytics?.payment_date),
        callScheduleDate: convertToString(callAnanlytics?.call_schedule_date),
        dispositionId: callAnanlytics?.disposition_id,
        notPaymentReason: convertToString(
          callAnanlytics?.detected_not_payment_reason,
        ),
        policyNumber: convertToString(callAnanlytics?.customer_policy_number),
        completedTenure: convertToString(
          callAnanlytics?.customer_completed_tenure,
        ),
        totalAmountPaid: convertToString(
          callAnanlytics?.customer_total_amount_paid,
        ),
        lastDueDate: convertToString(callAnanlytics?.customer_last_due_date),
        dueAmount: convertToString(callAnanlytics?.customer_due_amount),
        gender: convertToString(callAnanlytics?.gender),
        alternatePhoneNumber: convertToString(
          callAnanlytics?.alternate_phone_number,
        ),

        customerInsuredPersonName: convertToString(
          callAnanlytics?.customer_insured_person_name,
        ),
        customerNomineeName: convertToString(
          callAnanlytics?.customer_nominee_name,
        ),
        customerInsuranceCompany: convertToString(
          callAnanlytics?.customer_insurance_company,
        ),

        customerPlanName: convertToString(callAnanlytics?.customer_plan_name),
        customerLateFee: convertToString(callAnanlytics?.customer_late_fee),
        customerCurrentFundSurrenderValue: convertToString(
          callAnanlytics?.customer_current_fund_surrender_value,
        ),
        customerDeathCoverOriginal: convertToString(
          callAnanlytics?.customer_death_cover_original,
        ),
        customerDeathCoverReduced: convertToString(
          callAnanlytics?.customer_death_cover_reduced,
        ),
        customerLoanAmount: convertToString(
          callAnanlytics?.customer_loan_amount,
        ),
        customerInterestRate: convertToString(
          callAnanlytics?.customer_interest_rate,
        ),
        customerModeChangeAmount: convertToString(
          callAnanlytics?.customer_mode_change_amount,
        ),
        customerActualMode: convertToString(
          callAnanlytics?.customer_actual_mode,
        ),
        customerNewMode: convertToString(callAnanlytics?.customer_new_mode),
        customerAssignmentValue: convertToString(
          callAnanlytics?.customer_assignment_value,
        ),
        customerPolicyStatus: convertToString(
          callAnanlytics?.customer_policy_status,
        ),
        customerAnnualPremium: convertToString(
          callAnanlytics?.customer_annual_premium,
        ),
        customerGiveValue: convertToString(callAnanlytics?.customer_give_value),
        customerGetValue: convertToString(callAnanlytics?.customer_get_value),
        customerIssuedDate: convertToString(
          callAnanlytics?.customer_issued_date,
        ),
        customerLatePaymentChargesInterestRate: convertToString(
          callAnanlytics?.customer_late_payment_charges_interest_rate,
        ),
        callDuration: convertToString(callDuration),

        callRecording: dataObject?.callRecording,
        response_time: myDate,
        response_time_utc: dataObject.call_start_time,
        transcript: dataObject?.transcript,
      };
      return modifiedData;
    });

    setData(modifiedDataArray);
    setAllDataWithoutFilter(modifiedDataArray);
    filterDataLocally(modifiedDataArray);
  }, [tableData]);

  const editableField = [
    "totalRetailShop",
    "shopsToBeVisited",
    "focusedProduct",
    "callsMadeToday",
    "productiveCalls",
    "sellValueForToday",
    "officeMeeting",
  ];

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
      // defaultColumn: { Filter: DefaultColumnFilter },
    },
    useFilters,
    useSortBy,
    usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    initialState,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = tableInstance;
  initialState.pageSize = 10;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const iconColor = useColorModeValue("#2185d0");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [audioVisibility, setAudioVisibility] = useState(false);
  const userData = useSelector((state) => state.userData);
  const [audioUrl, setAudioUrl] = useState("");
  const [valSelectedColForEdit, setSelectedColForEdit] = useState({});
  const [analyticsDataResponse, setAnalyticsDataResponse] = useState(null);
  const [analyticsDataExportList, setAnalyticsDataExportList] = useState([]);
  const editValueRefOne = useRef(null);
  const editValueRefTwo = useRef(null);
  const editValueRefThree = useRef(null);
  const editValueRefFour = useRef(null);

  const audioRef = useRef(null);
  const [custFilterValue, setCustFilterValue] = useState({});
  console.log("valSelectedColForEdit---", valSelectedColForEdit);
  useEffect(() => {
    setTimeout(() => {
      if (
        isOpenEdit &&
        valSelectedColForEdit?.value &&
        editValueRefOne &&
        editValueRefTwo &&
        editValueRefThree &&
        editValueRefFour
      ) {
        if (isEvening) {
          editValueRefOne.current.value =
            valSelectedColForEdit.value.callsMadeToday;
          editValueRefTwo.current.value =
            valSelectedColForEdit.value.productiveCalls;
          editValueRefThree.current.value =
            valSelectedColForEdit.value.sellValueForToday;
          editValueRefFour.current.value =
            valSelectedColForEdit.value.officeMeeting;
        } else {
          editValueRefOne.current.value =
            valSelectedColForEdit.value.totalRetailShop;
          editValueRefTwo.current.value =
            valSelectedColForEdit.value.shopsToBeVisited;
          editValueRefThree.current.value =
            valSelectedColForEdit.value.focusedProduct;
        }

        // console.log("valSelectedColForEdit",valSelectedColForEdit);
      }
    }, 200);
  }, [isOpenEdit, valSelectedColForEdit]);
  const onOpenEdit = () => {
    setIsOpenEdit(true);
  };

  const onCloseEdit = (isOnSave) => {
    setIsOpenEdit(false);
    if (isOnSave) {
      if (isEvening) {
        valSelectedColForEdit.value.callsMadeToday =
          editValueRefOne.current.value;
        valSelectedColForEdit.value.productiveCalls =
          editValueRefTwo.current.value;
        valSelectedColForEdit.value.sellValueForToday =
          editValueRefThree.current.value;
        valSelectedColForEdit.value.officeMeeting =
          editValueRefFour.current.value.toLowerCase() === "yes" ? true : false;
      } else {
        valSelectedColForEdit.value.totalRetailShop =
          editValueRefOne.current.value;
        valSelectedColForEdit.value.shopsToBeVisited =
          editValueRefTwo.current.value;
        valSelectedColForEdit.value.focusedProduct =
          editValueRefThree.current.value;
      }

      saveEdittedValue();
    }
  };

  const saveEdittedValue = () => {
    updateAnalyticsValue({
      value: valSelectedColForEdit,
      isEvening: isEvening,
    });
  };

  const filterDataLocally = (modifiedDataArray) => {
    let dataArr = [...modifiedDataArray];

    if (Object.keys(custFilterValue).length) {
      dataArr = dataArr.filter(function (item) {
        let trueCounter = 0;
        for (var key in custFilterValue) {
          if (
            item[key] &&
            custFilterValue[key] &&
            item[key].toLowerCase().includes(custFilterValue[key].toLowerCase())
          ) {
            trueCounter++;
            // console.log("trueCounter",trueCounter,Object.keys(custFilterValue).length);
          }
        }
        if (Object.keys(custFilterValue).length === trueCounter) {
          return true;
        }
        return false;
      });
      setData(dataArr);
    } else {
      setData(dataArr);
    }
  };
  useEffect(() => {
    let dataArr = [...allDataWithoutFilter];
    filterDataLocally(dataArr);
  }, [custFilterValue]);

  async function handleDownloadExcel() {
    dispatch(setLoader(true));

    try {
      const basePayload = {
        selectedDateRange: props.selectedDateRange,
        clientName: "NICL",
        scenarioID: props.workFlowData?.id,
        token: userData.token,
        limit: 500,
        page: 1,
      };

      let genData = [];

      // 1️⃣ First page
      const firstRes = await getAnalyticsApiData(basePayload);
      const totalCount = Number(firstRes.data.totalCount);
      const totalPages = Math.ceil(totalCount / 500)+1;

      genData = [...firstRes.data.results];

      // 2️⃣ Fetch remaining pages synchronously
      for (let page = 2; page <= totalPages; page++) {
        const res = await getAnalyticsApiData({
          ...basePayload,
          page,
        });

        genData = [...genData, ...res.data.results];
        console.log(`Fetched page ${page} of ${totalPages}`, genData);
      }

      // 3️⃣ Set final data
      setAnalyticsDataExportList(genData);

      // 4️⃣ Export directly (no useEffect dependency)
      // setTimeout(() => {
        downloadExcelFile(genData);
      // }, 2000);
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      dispatch(setLoader(false));
    }
  }

  function downloadExcelFile(genData) {
    console.log("Exporting Excel with data:", analyticsDataExportList);
    const headersArray = columnsData.map((column) => {
      return column.Header;
    });

    // headersArray.splice(headersArray?.length - 2, 0, "Transcription");
    // headersArray.push("Is Call 20+ Min");

    const generateTranscription = (transcript) => {
      let transcriptMessage = "";
      if (transcript && transcript.length) {
        for (let i = 0; i < transcript.length; i++) {
          if (transcript[i].bot) {
            transcriptMessage =
              transcriptMessage +
              "Bot : " +
              transcript[i]?.message[0] +
              " || \n";
          } else {
            transcriptMessage =
              transcriptMessage +
              "Customer : " +
              transcript[i]?.message[0] +
              " || \n";
          }
        }

        if (transcriptMessage.length > 30000) {
          return transcriptMessage.substring(0, 30000) + "...";
        }
        return transcriptMessage;
      }
    };

    let modifiedDataArray = genData.map((dataObject) => {
      let myDate = convertDateToLocal(dataObject.call_start_time);
      const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      let callDuration = convertCallDurationToMinExcel(dataObject.callDuration);
      let callAnanlytics = dataObject?.callAnanlytics;
      // console.log("callAnanlytics?.apply_card",convertToString(callAnanlytics.apply_card))
      //convert non string data to string using convertToString() Function
      let modifiedData = {
        phoneNumber: dataObject?.userId,
        sessionId: dataObject?.sessionId,
        callInfo: checkCallInfo(callAnanlytics),
        issueResolved: convertToString(callAnanlytics?.issue_resolved),
        call_transfer: convertToString(callAnanlytics?.callback_requested),
        callNotComplete: convertToString(callAnanlytics?.call_not_completed),
        callAbandoned: convertToString(dataObject?.call_abandoned),
        csatRating:convertToString(callAnanlytics?.feedback_rating),
        callDuration: callDuration,
        callRecording: getAudioEndpoint(dataObject, true),
        customerQueries: convertToString(
          callAnanlytics?.list_of_customer_queries,
        ),
        l1SubQuery: convertToString(callAnanlytics?.L1_sub_query),
        l2SubQuery: convertToString(callAnanlytics?.L2_sub_query),
        l3SubQuery: convertToString(callAnanlytics?.L3_sub_query),
        // issue_resolved: convertToString(
        //   callAnanlytics?.issue_resolved === true
        //     ? callAnanlytics?.issue_resolved
        //     : false
        // ),
        callBackArrangedBy: convertToString(
          callAnanlytics?.call_back_requested_by,
        ),
        callBackType: checkCallBackType(callAnanlytics),

        // conversationCompleted: convertToString(
        //   callAnanlytics?.conversationCompleted
        // ),

        callType: convertToString(callAnanlytics?.call_type),

        // transcription: generateTranscription(dataObject?.transcript),
        language: convertToString(callAnanlytics?.language),

        response_time: myDate,
        // is_20_plus:Number(dataObject.callDuration)>20*60 ?"Yes":"No",
      };

      return modifiedData;
    });

    console.log("modified data array", modifiedDataArray);

    // console.log("modified data array",modifiedDataArray)
    if (modifiedDataArray?.length) {
      downloadExcel({
        fileName: title.replaceAll(" ", ""),
        sheet: title.replaceAll(" ", ""),
        tablePayload: {
          header: headersArray,
          body: modifiedDataArray,
        },
      });
      setAnalyticsDataExportList([]);
      setAnalyticsDataResponse(null);
    }
  }
  useEffect(() => {
    if (
      analyticsDataResponse &&
      analyticsDataResponse.totalCount === analyticsDataExportList.length
    ) {
      console.log("Reached End");
      // downloadExcelFile();
      dispatch(setLoader(false));
    }
  }, [analyticsDataExportList, analyticsDataResponse]);

  const triggerOtherAudioDisplay = () => {
    console.log("trigger other audio display");
    setAudioVisibility(true);
  };

  const getAudioEndpoint = (data, woSAS = true) => {
    const url = data?.callRecording;
    const timestamp = data?.response_time_utc || data?.response_time;

    const date = new Date(timestamp);

    // Format YYYY/MM/DD/
    const formatted =
      "/" +
      date.getFullYear() +
      "/" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "/" +
      String(date.getDate()).padStart(2, "0") +
      "/";

    console.log("formatted date", formatted);
    if (url) {
      // setAudioUrl(cell.value);
      const parts = url.split("/");
      let fileName = "";
      if (parts.length > 0) {
        console.log("File Name", parts[parts.length - 1]);
        fileName = parts[parts.length - 1];
      }

      let modifiedUrl = `https://teckinfostoragejiowest.blob.core.windows.net/teckinfo-call-recordings${formatted}${fileName}`;
      if (woSAS) {
        return modifiedUrl;
      }
      const audioUrlFromBlob = downloadAudioFileFromBlob(modifiedUrl);
      console.log("Aduio url ---->", audioUrlFromBlob);

      return audioUrlFromBlob;
    }
  };
  const getAudioFromBlob = async (data) => {
    console.log("Incoming Audio Url", data.callRecording);
    const url = getAudioEndpoint(data, false);
    console.log("Modified Audio Url", url);

    // let blobResponse = await processWAVfilreApi({ wavUrl: url });

    // return audioUrlFromBlob;

    setAudioUrl(url);
  };

  console.log("Audio url updated------->", audioUrl);
  function convertToBold(text) {
    // Use a regular expression to find text wrapped in **
    return text.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");
  }

  const handleTriggerRefresh = async () => {
    if (valSelectedColForEdit?.data?.sessionId) {
      console.log("Session Id", valSelectedColForEdit?.data?.sessionId);
      try {
        const payload = {
          sessionId: valSelectedColForEdit?.data?.sessionId,
        };
        await triggerAnalyticsRefreshApi(payload);
        // alert("Data Reprocessed Successfully");
        setOpenCallSummaryInformationModal(false);
        if (props.triggerRefetch) {
          props.triggerRefetch();
        }
      } catch (error) {
        console.error("Error reprocessing data:", error);
        alert("Failed to Reprocess Data");
      }
    }
  };

  const handleMakeResolved = async () => {
    if (valSelectedColForEdit?.data?.sessionId) {
      console.log("Session Id", valSelectedColForEdit?.data?.sessionId);
      try {
        const payload = {
          sessionId: valSelectedColForEdit?.data?.sessionId,
        };
        await makeCallResolvedApi(payload);
        setOpenCallSummaryInformationModal(false);
        if (props.triggerRefetch) {
          props.triggerRefetch();
        }
      } catch (error) {
        console.error("Error marking issue as resolved:", error);
        alert("Failed to mark issue as resolved");
      }
    }
  };

  function SplitStringComponent(text) {
    if (text) {
      const lines = text.split("\n");
      // console.log("Lines",lines)
      return (
        <div>
          {lines.map((line, index) => (
            <>
              <div
                dangerouslySetInnerHTML={{ __html: convertToBold(line) }}
              ></div>

              {/* <br></br> */}
            </>
          ))}
        </div>
      );
    } else {
      return null;
    }
  }
  console.log("Filter inputs", custFilterValue);
  console.log(
    "Clicked===",
    valSelectedColForEdit,
    openCallSummaryInformationModal,
  );
  return (
    <Card direction="column" mh="400px" w="100%" px="0px" pt="20px">
      <Flex px="25px" justify="space-between" mb="15px" align="center">
        <Text
          color={textColor}
          fontSize="15px"
          fontWeight="700"
          lineHeight="100%"
        >
          {title}
        </Text>
        <Box className="headRight">
          <Box className="filterButton">
            <Button
              size="sm"
              colorScheme={props.analyticsFilter.isfilter ? "blue" : "black"}
              // leftIcon={<MdDownload />}
              onClick={() => {
                props.applyFilterAnalytisData();
              }}
            >
              Apply Filter
            </Button>
            <Button
              size="sm"
              colorScheme="red"
              // leftIcon={<MdDownload />}
              onClick={() => {
                setCustFilterValue({});
                props.discardFilterAnalytisData();
              }}
            >
              Clear
            </Button>
          </Box>
          <Button
            size="sm"
            colorScheme="blue"
            leftIcon={<MdDownload />}
            onClick={() => {
              handleDownloadExcel();
            }}
          >
            Export
          </Button>
        </Box>
      </Flex>
      <div className="analyticsTable policyRenewal">
        <Table
          {...getTableProps()}
          m="15px auto"
          size="sm"
          variant="striped"
          colorScheme="blackAlpha"
          display="block"
        >
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    // {...column.getHeaderProps(column.getSortByToggleProps())}
                    pe="10px"
                    key={index}
                    borderColor={borderColor}
                  >
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize="10px"
                      color="gray.400"
                    >
                      {column.render("Header")}
                    </Flex>
                    <span>
                      {column.canFilter ? (
                        <Input
                          variant="filled"
                          size="sm"
                          value={
                            custFilterValue[column.id] &&
                            custFilterValue[column.id].length > 0
                              ? custFilterValue[column.id]
                              : ""
                          }
                          // placeholder={custFilterValue[column.id]?"Ok":"Filter"}
                          onChange={(e) => {
                            if (column.id === "phoneNumber") {
                              props.setAnalyticsFilter({
                                ...props.analyticsFilter,
                                phoneNumber: e.target.value,
                                isfilter:
                                  e.target.value.length === 0 ? false : true,
                              });
                            }
                            if (column.id === "sessionId") {
                              props.setAnalyticsFilter({
                                ...props.analyticsFilter,
                                sessionId: e.target.value,
                                isfilter:
                                  e.target.value.length === 0 ? false : true,
                              });
                            }
                            if (column.id === "customerName") {
                              props.setAnalyticsFilter({
                                ...props.analyticsFilter,
                                customerName: e.target.value,
                                isfilter:
                                  e.target.value.length === 0 ? false : true,
                              });
                            }
                            if (column.id === "language") {
                              props.setAnalyticsFilter({
                                ...props.analyticsFilter,
                                language: e.target.value,
                                isfilter:
                                  e.target.value.length === 0 ? false : true,
                              });
                            }
                            if (column.id === "sendSms") {
                              props.setAnalyticsFilter({
                                ...props.analyticsFilter,
                                sendSms: e.target.value,
                                isfilter:
                                  e.target.value.length === 0 ? false : true,
                              });
                            }

                            if (column.id === "customerQueries") {
                              props.setAnalyticsFilter({
                                ...props.analyticsFilter,
                                customerQueries: e.target.value,
                                isfilter:
                                  e.target.value.length === 0 ? false : true,
                              });
                            }
                            if (column.id === "l1SubQuery") {
                              props.setAnalyticsFilter({
                                ...props.analyticsFilter,
                                l1SubQuery: e.target.value,
                                isfilter:
                                  e.target.value.length === 0 ? false : true,
                              });
                            }
                            if (column.id === "l2SubQuery") {
                              props.setAnalyticsFilter({
                                ...props.analyticsFilter,
                                l2SubQuery: e.target.value,
                                isfilter:
                                  e.target.value.length === 0 ? false : true,
                              });
                            }
                            if (column.id === "l3SubQuery") {
                              props.setAnalyticsFilter({
                                ...props.analyticsFilter,
                                l3SubQuery: e.target.value,
                                isfilter:
                                  e.target.value.length === 0 ? false : true,
                              });
                            }

                            let tempCustFilterRef = Object.assign(
                              {},
                              custFilterValue,
                            );
                            if (
                              tempCustFilterRef[column.id] &&
                              e.target.value.length === 0
                            ) {
                              delete tempCustFilterRef[column.id];
                            } else {
                              tempCustFilterRef[column.id] = e.target.value;
                            }
                            setCustFilterValue(tempCustFilterRef);
                          }}
                          placeholder={"Filter"}
                          htmlSize={4}
                          width="auto"
                        />
                      ) : null}
                    </span>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()} overflow="auto">
            {page.map((row, rowindex) => {
              prepareRow(row);
              return (
                <Tr
                  onClick={(e) => {
                    console.log("Row clicked");
                    getAudioFromBlob(row.original);
                    setOpenCallSummaryInformationModal(true);
                    setSelectedColForEdit({
                      data: row.original,
                    });
                  }}
                  {...row.getRowProps()}
                  key={rowindex}
                  style={{
                    border:
                      highlightEditingRow === rowindex ? "solid #000000" : null,
                  }}
                >
                  {row.cells.map((cell, index) => {
                    let data = "";
                    if (cell.column.Header === "Call Recording") {
                      data = (
                        <Flex align="center">
                          <Icon
                            w="24px"
                            h="24px"
                            me="5px"
                            _hover={{ cursor: "pointer" }}
                            _focus={{ boxShadow: "outline" }}
                            as={MdPlayArrow}
                            color={iconColor}
                            onClick={(e) => {
                              getAudioFromBlob(cell.row.original);
                              // setAudioUrl(cell.value);
                              setSelectedColForEdit({
                                data: cell.row.original,
                              });
                              onOpen();
                              e.stopPropagation();
                            }}
                          />
                        </Flex>
                      );
                    } else if (editableField.includes(cell.column.id)) {
                      data = (
                        <>
                          <span className="editText">
                            <Text
                              color={textColor}
                              fontSize="sm"
                              fontWeight="700"
                            >
                              {cell.value}
                            </Text>
                            <Icon
                              w="24px"
                              h="24px"
                              me="5px"
                              _hover={{ cursor: "pointer" }}
                              _focus={{ boxShadow: "outline" }}
                              as={MdEdit}
                              color={iconColor}
                              onClick={() => {
                                setHighlightEditingRow(rowindex);
                                setSelectedColForEdit({
                                  sessionId: cell.row.original.sessionId,
                                  id: cell.column.id,
                                  index: cell.row.index,
                                  value: cell.row.original,
                                });
                                onOpenEdit();
                              }}
                            />
                          </span>
                        </>
                      );
                    } else {
                      data = (
                        <>
                          <Text
                            color={textColor}
                            fontSize="sm"
                            fontWeight="700"
                            title={cell.value}
                            sx={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100%", // or a fixed width like '150px'
                              display: "block",
                              cursor: "default",
                            }}
                          >
                            {cell.value}
                          </Text>
                        </>
                      );
                    }
                    return (
                      <Td
                        {...cell.getCellProps()}
                        key={index}
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "150px", md: "20px", lg: "auto" }}
                        borderColor="transparent"
                      >
                        {data}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </div>
      <div className="pagination" style={{ margin: "25px 30px 0px 25px" }}>
        <HStack className="bottomPagination">
          <div className="pageChangeBtn">
            <Button
              size="sm"
              onClick={() => {
                props.setAnalyticsTablePageNo(1);
              }}
              disabled={!canPreviousPage}
            >
              {"<<"}
            </Button>{" "}
            <Button
              size="sm"
              onClick={() => {
                props.setAnalyticsTablePageNo(props.analyticsTablePageNo - 1);
              }}
              disabled={!canPreviousPage}
            >
              {"<"}
            </Button>{" "}
            <Button
              size="sm"
              onClick={() => {
                props.setAnalyticsTablePageNo(props.analyticsTablePageNo + 1);
              }}
              disabled={!canNextPage}
            >
              {">"}
            </Button>{" "}
            <Button
              size="sm"
              onClick={() => {
                props.setAnalyticsTablePageNo(
                  Math.round(
                    tableData.totalCount / props.pageLimitanalyticsTable,
                  ),
                );
              }}
              disabled={!canNextPage}
            >
              {">>"}
            </Button>{" "}
          </div>
          <div className="pageCounter">
            <Text fontSize="sm">
              Page{" "}
              <strong>
                {/* {pageIndex + 1} of {pageOptions.length} */}
                {props.analyticsTablePageNo} of
                {Math.round(
                  tableData.totalCount / props.pageLimitanalyticsTable,
                )}
              </strong>{" "}
            </Text>
            <span>|</span>
            <Text fontSize="sm">
              Go to page:{" "}
              <Input
                type="number"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  props.setAnalyticsTablePageNo(page);
                }}
                variant="filled"
                size="xs"
                width="20%"
              />
            </Text>
            <Select
              value={props.pageLimitanalyticsTable}
              onChange={(e) => {
                props.setLimitAnalyticsTable(Number(e.target.value));
                setPageSize(Number(e.target.value));
              }}
              variant="filled"
              size={"xs"}
              width={"auto"}
            >
              {[10, 50, 100].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </Select>
          </div>
        </HStack>
        <br></br>
      </div>

      {openCallSummaryInformationModal && (
        <Modal
          isOpen={openCallSummaryInformationModal}
          onClose={() => {
            setOpenCallSummaryInformationModal(false);
          }}
          size={"6xl"}
          isCentered
        >
          <ModalOverlay />
          <ModalContent maxH="90vh" overflow="hidden">
            <ModalHeader>Call Summary & Analysis</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6} overflowY="auto">
              <Flex direction="column" gap={6}>
                {/* Top Section: Info & Recording */}
                <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={6}>
                  {/* Session Details */}
                  <Card
                    variant="outline"
                    p={4}
                    borderRadius="md"
                    boxShadow="sm"
                  >
                    <Text fontSize="lg" fontWeight="bold" mb={4}>
                      Session Details
                    </Text>
                    <Grid templateColumns="1fr 1fr" gap={4}>
                      <Box>
                        <Text fontSize="sm" color="gray.500">
                          Session ID
                        </Text>
                        <Text fontSize="md" fontWeight="medium">
                          {valSelectedColForEdit?.data?.sessionId || "-"}
                        </Text>
                      </Box>
                      <Box>
                        <Text fontSize="sm" color="gray.500">
                          Date & Time
                        </Text>
                        <Text fontSize="md" fontWeight="medium">
                          {valSelectedColForEdit?.data?.response_time || "-"}
                        </Text>
                      </Box>
                      <Box>
                        <Text fontSize="sm" color="gray.500">
                          Customer Name
                        </Text>
                        <Text fontSize="md" fontWeight="medium">
                          {valSelectedColForEdit?.data?.customerName || "-"}
                        </Text>
                      </Box>
                      <Box>
                        <Text fontSize="sm" color="gray.500">
                          Phone Number
                        </Text>
                        <Text fontSize="md" fontWeight="medium">
                          {valSelectedColForEdit?.data?.phoneNumber || "-"}
                        </Text>
                      </Box>
                      <Box>
                        <Text fontSize="sm" color="gray.500">
                          Disposition
                        </Text>
                        <Text fontSize="md" fontWeight="medium">
                          {valSelectedColForEdit?.data?.issue_resolved ===
                          "true"
                            ? "Issue resolved"
                            : "Issue not resolved / requested call back"}
                        </Text>
                      </Box>
                      <Box>
                        <Text fontSize="sm" color="gray.500">
                          Call Quality
                        </Text>
                        <HStack spacing={1}>
                          {valSelectedColForEdit?.data?.csatRating??"NA"} {[...Array(Number(valSelectedColForEdit?.data?.csatRating??0))].map((_, i) => (
                            <Star key={i} fontSize="small" color="action" />
                          ))}
                        </HStack>
                      </Box>
                    </Grid>
                  </Card>

                  {/* Recording Player */}
                  {/* Status Overview (Was Call Recording) */}
                  <Card
                    variant="outline"
                    p={3}
                    borderRadius="md"
                    boxShadow="sm"
                  >
                    <Text fontSize="md" fontWeight="bold" mb={3}>
                      Call Status
                    </Text>
                    <SimpleGrid columns={2} spacing={3}>
                      {/* Conv. Completed */}
                      <Box
                        p={2}
                        borderRadius="md"
                        bg={
                          valSelectedColForEdit?.data?.conversationCompleted ===
                          "true"
                            ? "green.50"
                            : "red.50"
                        }
                        border="1px solid"
                        borderColor={
                          valSelectedColForEdit?.data?.conversationCompleted ===
                          "true"
                            ? "green.200"
                            : "red.200"
                        }
                      >
                        <Text fontSize="xs" fontWeight="bold" color="gray.600">
                          Completed?
                        </Text>
                        <Badge
                          colorScheme={
                            valSelectedColForEdit?.data
                              ?.conversationCompleted === "true"
                              ? "green"
                              : "red"
                          }
                          fontSize="xs"
                          borderRadius="full"
                        >
                          {valSelectedColForEdit?.data
                            ?.conversationCompleted === "true"
                            ? "Yes"
                            : "No"}
                        </Badge>
                      </Box>

                      {/* Disposition */}
                      <Box
                        p={2}
                        borderRadius="md"
                        bg={
                          valSelectedColForEdit?.data?.issue_resolved === "true"
                            ? "green.50"
                            : "orange.50"
                        }
                        border="1px solid"
                        borderColor={
                          valSelectedColForEdit?.data?.issue_resolved === "true"
                            ? "green.200"
                            : "orange.200"
                        }
                      >
                        <Text fontSize="xs" fontWeight="bold" color="gray.600">
                          Disposition
                        </Text>
                        <Text fontSize="xs" fontWeight="semibold">
                          {valSelectedColForEdit?.data?.issue_resolved ===
                          "true"
                            ? "Resolved"
                            : "Not Resolved"}
                        </Text>
                      </Box>

                      {/* Callback Requested By */}
                      <Box
                        p={2}
                        borderRadius="md"
                        bg="blue.50"
                        border="1px solid"
                        borderColor="blue.200"
                      >
                        <Text fontSize="xs" fontWeight="bold" color="gray.600">
                          Callback By
                        </Text>
                        <Text fontSize="xs" fontWeight="semibold">
                          {valSelectedColForEdit?.data?.callBackArrangedBy ||
                            "-"}
                        </Text>
                      </Box>

                      {/* Callback Type */}
                      <Box
                        p={2}
                        borderRadius="md"
                        bg="purple.50"
                        border="1px solid"
                        borderColor="purple.200"
                      >
                        <Text fontSize="xs" fontWeight="bold" color="gray.600">
                          Callback Type
                        </Text>
                        <Text fontSize="xs" fontWeight="semibold">
                          {valSelectedColForEdit?.data?.callBackType || "-"}
                        </Text>
                      </Box>
                    </SimpleGrid>
                  </Card>
                </Grid>

                {/* Middle Section: Queries & Summary */}
                <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={6}>
                  {/* LEFT SIDE: Combined Queries */}
                  <Card variant="outline" p={4} borderRadius="md" h="100%">
                    <Text fontSize="lg" fontWeight="bold" mb={4}>
                      Query Analysis
                    </Text>
                    <VStack align="stretch" spacing={4}>
                      {/* Customer Queries Section */}
                      <Box>
                        <Text
                          fontSize="sm"
                          fontWeight="bold"
                          color="gray.600"
                          mb={2}
                        >
                          Customer Queries
                        </Text>
                        <Box
                          h="120px"
                          overflowY="auto"
                          p={3}
                          bg="gray.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="gray.100"
                        >
                          <Text whiteSpace="pre-wrap" fontSize="sm">
                            {valSelectedColForEdit?.data?.customerQueries ||
                              "No queries found."}
                          </Text>
                        </Box>
                      </Box>

                      {/* Sub-Queries Section */}
                      <Box>
                        <Text
                          fontSize="sm"
                          fontWeight="bold"
                          color="gray.600"
                          mb={2}
                        >
                          Sub-Queries
                        </Text>
                        <Box
                          h="150px"
                          overflowY="auto"
                          p={3}
                          bg="gray.50"
                          borderRadius="md"
                          border="1px solid"
                          borderColor="gray.100"
                        >
                          <VStack align="start" spacing={3}>
                            <Box w="100%">
                              <Text
                                fontSize="xs"
                                color="gray.500"
                                fontWeight="bold"
                              >
                                L1 Sub Query
                              </Text>
                              <Text fontSize="sm">
                                {valSelectedColForEdit?.data?.l1SubQuery || "-"}
                              </Text>
                            </Box>
                            <Box w="100%">
                              <Text
                                fontSize="xs"
                                color="gray.500"
                                fontWeight="bold"
                              >
                                L2 Sub Query
                              </Text>
                              <Text fontSize="sm">
                                {valSelectedColForEdit?.data?.l2SubQuery || "-"}
                              </Text>
                            </Box>
                            <Box w="100%">
                              <Text
                                fontSize="xs"
                                color="gray.500"
                                fontWeight="bold"
                              >
                                L3 Sub Query
                              </Text>
                              <Text fontSize="sm">
                                {valSelectedColForEdit?.data?.l3SubQuery || "-"}
                              </Text>
                            </Box>
                          </VStack>
                        </Box>
                      </Box>
                    </VStack>
                  </Card>

                  {/* RIGHT SIDE: Call Transcript */}
                  <Card variant="outline" p={4} borderRadius="md" h="100%">
                    <Text fontSize="lg" fontWeight="bold" mb={4}>
                      Call Transcript
                    </Text>
                    <Box mb={4}>
                      {audioUrl ? (
                        <Box w="100%" p={2} bg="gray.50" borderRadius="md">
                          <audio
                            controls
                            style={{ width: "100%", height: "30px" }}
                            src={audioUrl}
                          >
                            <source src={audioUrl} type="audio/wav" />
                            <source src={audioUrl} type="audio/x-wav" />
                          </audio>
                        </Box>
                      ) : (
                        <Text fontSize="sm" color="gray.500">
                          No recording available
                        </Text>
                      )}
                    </Box>
                    <Box
                      h="400px" // Increased height to match left side
                      overflowY="auto"
                      p={4}
                      bg="gray.50"
                      borderRadius="md"
                    >
                      <VStack spacing={4} align="stretch">
                        {valSelectedColForEdit?.data?.transcript &&
                        valSelectedColForEdit?.data?.transcript.length > 0 ? (
                          valSelectedColForEdit?.data?.transcript.map(
                            (item, index) => (
                              <Flex
                                key={index}
                                justify={item.bot ? "flex-start" : "flex-end"}
                              >
                                <Box
                                  maxW="70%"
                                  bg={item.bot ? "white" : "blue.50"}
                                  color="gray.800"
                                  p={3}
                                  borderRadius="lg"
                                  boxShadow="sm"
                                  borderTopLeftRadius={item.bot ? 0 : "lg"}
                                  borderTopRightRadius={item.bot ? "lg" : 0}
                                  border="1px solid"
                                  borderColor={
                                    item.bot ? "gray.200" : "blue.200"
                                  }
                                >
                                  <Text
                                    fontSize="xs"
                                    fontWeight="bold"
                                    color={item.bot ? "blue.600" : "blue.700"}
                                    mb={1}
                                  >
                                    {item.bot ? "Bot" : "Customer"}
                                  </Text>
                                  {item.message &&
                                    item.message.map((msg, msgIndex) => (
                                      <Text key={msgIndex} fontSize="sm">
                                        {msg}
                                      </Text>
                                    ))}
                                  <Text
                                    fontSize="xs"
                                    color={item.bot ? "gray.400" : "gray.500"}
                                    textAlign="right"
                                    mt={1}
                                  >
                                    {new Date(
                                      item.response_time,
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })}
                                  </Text>
                                </Box>
                              </Flex>
                            ),
                          )
                        ) : (
                          <Text color="gray.500" textAlign="center">
                            No transcript available.
                          </Text>
                        )}
                      </VStack>
                    </Box>
                  </Card>
                </Grid>

                {/* Bottom Section: Status Cards */}

                {/* Bottom Section: Analytics (Commented Out) */}
                {/* <Card variant="outline" p={4} borderRadius="md">
                  <Text fontSize="lg" fontWeight="bold" mb={4}>
                    Analytics Insights
                  </Text>
                  <Grid
                    templateColumns={{
                      base: "repeat(2, 1fr)",
                      md: "repeat(4, 1fr)",
                    }}
                    gap={4}
                  >
                    <Box p={3} bg="blue.50" borderRadius="md">
                      <Text
                        fontSize="xs"
                        fontWeight="bold"
                        color="blue.600"
                        mb={1}
                      >
                        Intent
                      </Text>
                      <Text fontSize="sm">
                        {valSelectedColForEdit?.data?.summary?.answer?.intent ||
                          "-"}
                      </Text>
                    </Box>
                    <Box p={3} bg="green.50" borderRadius="md">
                      <Text
                        fontSize="xs"
                        fontWeight="bold"
                        color="green.600"
                        mb={1}
                      >
                        Sentiment
                      </Text>
                      <Box fontSize="sm">
                        {SplitStringComponent(
                          valSelectedColForEdit?.data?.summary?.answer
                            ?.detected_sentiment || "-"
                        )}
                      </Box>
                    </Box>
                    <Box p={3} bg="purple.50" borderRadius="md">
                      <Text
                        fontSize="xs"
                        fontWeight="bold"
                        color="purple.600"
                        mb={1}
                      >
                        Upsell/Cross-sell
                      </Text>
                      <Text fontSize="sm">
                        {valSelectedColForEdit?.data?.summary?.answer
                          ?.upsell_crosssell || "-"}
                      </Text>
                    </Box>
                    <Box p={3} bg="red.50" borderRadius="md">
                      <Text
                        fontSize="xs"
                        fontWeight="bold"
                        color="red.600"
                        mb={1}
                      >
                        Objections
                      </Text>
                      <Text fontSize="sm">
                        {valSelectedColForEdit?.data?.summary?.answer
                          ?.detected_objection || "-"}
                      </Text>
                    </Box>
                    <Box p={3} bg="orange.50" borderRadius="md">
                      <Text
                        fontSize="xs"
                        fontWeight="bold"
                        color="orange.600"
                        mb={1}
                      >
                        Lead Signal
                      </Text>
                      <Text fontSize="sm">
                        {valSelectedColForEdit?.data?.summary?.answer
                          ?.detected_lead || "-"}
                      </Text>
                    </Box>
                    <Box p={3} bg="red.50" borderRadius="md">
                      <Text
                        fontSize="xs"
                        fontWeight="bold"
                        color="red.600"
                        mb={1}
                      >
                        Abuse/Hate
                      </Text>
                      <Text fontSize="sm">
                        {valSelectedColForEdit?.data?.summary?.answer
                          ?.abusive_detection || "-"}
                      </Text>
                    </Box>
                    <Box p={3} bg="yellow.50" borderRadius="md">
                      <Text
                        fontSize="xs"
                        fontWeight="bold"
                        color="yellow.600"
                        mb={1}
                      >
                        Legal Escalation
                      </Text>
                      <Text fontSize="sm">
                        {valSelectedColForEdit?.data?.summary?.answer
                          ?.legal_escalation || "-"}
                      </Text>
                    </Box>
                    <Box p={3} bg="cyan.50" borderRadius="md">
                      <Text
                        fontSize="xs"
                        fontWeight="bold"
                        color="cyan.600"
                        mb={1}
                      >
                        Social Escalation
                      </Text>
                      <Text fontSize="sm">
                        {valSelectedColForEdit?.data?.summary?.answer
                          ?.social_escalation || "-"}
                      </Text>
                    </Box>
                  </Grid>
                </Card> */}
              </Flex>
            </ModalBody>

            <ModalFooter>
              <Button
                onClick={() => {
                  setOpenCallSummaryInformationModal(false);
                }}
              >
                Close
              </Button>
              <Button
                colorScheme="blue"
                onClick={() => {
                  handleTriggerRefresh();
                }}
              >
                Reprocess
              </Button>
              <Button
                colorScheme="green"
                ml={3}
                onClick={() => {
                  handleMakeResolved();
                }}
              >
                Make Resolved
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}

      {isOpen && (
        <>
          <Modal
            isOpen={isOpen}
            onClose={() => {
              onClose();
              setAudioVisibility(false);
            }}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Audio</ModalHeader>

              <ModalBody style={{ height: "40em" }}>
                {/* controlsList="nodownload" */}
                <Text fontSize="sm">
                  Customer Name : {valSelectedColForEdit?.data?.customerName}
                </Text>
                <Text fontSize="sm">
                  Phone Number : {valSelectedColForEdit?.data?.phoneNumber}
                </Text>
                <Text fontSize="sm">
                  Session Id : {valSelectedColForEdit?.data?.sessionId}
                </Text>
                <br></br>
                {/* <Button
                  onClick={() => {
                    window.open(audioUrl, "_blank");
                  }}
                >
                  Download Audio
                </Button> */}
                <figure style={{ margin: "10px auto" }}>
                  <audio
                    preload="auto"
                    src={audioUrl}
                    // onCanPlayThrough={() => triggerOtherAudioDisplay()}
                    onCanPlay={() => triggerOtherAudioDisplay()}
                    onLoadedMetadata={() => console.log("metadata loaded")}
                    onError={(e) => console.log("audio load error:", e)}
                  >
                    <source src={audioUrl} type="audio/wav" />
                    <source src={audioUrl} type="audio/x-wav" />
                    <source src={audioUrl} type="audio/vnd.wave" />
                  </audio>
                  {audioVisibility ? (
                    <audio
                      controls
                      style={{ width: "100%" }}
                      src={audioUrl}
                      ref={audioRef}
                    >
                      <source src={audioUrl} type="audio/wav" />
                      <source src={audioUrl} type="audio/x-wav" />
                      <source src={audioUrl} type="audio/vnd.wave" />
                      {/* <a href="/media/cc0-audio/t-rex-roar.mp3">Download audio</a> */}
                    </audio>
                  ) : null}
                </figure>
              </ModalBody>

              <ModalFooter>
                <Button
                  leftIcon={<MdDownload />}
                  colorScheme="blue"
                  variant="solid"
                  style={{ width: "180px" }}
                  mr={3}
                  onClick={() => {
                    window.open(audioUrl, "_blank");
                  }}
                >
                  Download Audio
                </Button>
                <Button
                  onClick={() => {
                    onClose();
                    setAudioVisibility(false);
                  }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </>
      )}

      {isOpenEdit && (
        <Window
          id="react-window-audio"
          height={440}
          width={600}
          resizable={true}
          titleBar={{
            title: "Analytics Data Editing",
            buttons: {
              minimize: false,
              maximize: false,
              close: () => {
                onCloseEdit(false);
                setAudioVisibility(false);
                setHighlightEditingRow(null);
              },
            },
          }}
        >
          <div className="editAudioModal">
            <div className="infoHeader">
              <div className="phoneNumb">
                <Icon
                  w="16px"
                  h="16px"
                  me="5px"
                  _hover={{ cursor: "pointer" }}
                  _focus={{ boxShadow: "outline" }}
                  as={MdPhone}
                  color={iconColor}
                  onClick={() => {}}
                />
                <Text>{`${valSelectedColForEdit.value.phoneNumber} (${valSelectedColForEdit.value.sessionId})`}</Text>
              </div>
              <div className="timeCircle">
                <Icon
                  w="16px"
                  h="16px"
                  me="5px"
                  _hover={{ cursor: "pointer" }}
                  _focus={{ boxShadow: "outline" }}
                  as={MdLockClock}
                  color={iconColor}
                  onClick={() => {}}
                />
                <Text>{valSelectedColForEdit.value.timestamp}</Text>
              </div>
            </div>

            <div className="editAudio">
              <figure style={{ margin: "10px auto" }}>
                <audio
                  preload="auto"
                  src={audioUrl}
                  onCanPlayThrough={() => triggerOtherAudioDisplay()}
                ></audio>
                {audioVisibility ? (
                  <audio
                    controls
                    style={{ width: "100%" }}
                    src={audioUrl}
                    ref={audioRef}
                  >
                    {/* <a href="/media/cc0-audio/t-rex-roar.mp3">Download audio</a> */}
                  </audio>
                ) : null}
              </figure>
            </div>
            <div className="editOptions">
              {isEvening && (
                <div className="formGroup">
                  <div className="rowBlock">
                    <label className="colLeft">{columnsData[5].Header}</label>
                    <div className="colRight">
                      <Input
                        className="form-control"
                        ref={editValueRefFour}
                        variant="filled"
                        size="lg"
                        placeholder={"Value"}
                        width="auto"
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="formGroup">
                <div className="rowBlock">
                  <label className="colLeft">
                    {isEvening ? columnsData[6].Header : columnsData[5].Header}
                  </label>
                  <div className="colRight">
                    <Input
                      className="form-control"
                      ref={editValueRefOne}
                      variant="filled"
                      size="lg"
                      placeholder={"Value"}
                      width="auto"
                    />
                  </div>
                </div>
              </div>
              <div className="formGroup">
                <div className="rowBlock">
                  <label className="colLeft">
                    {isEvening ? columnsData[7].Header : columnsData[6].Header}
                  </label>
                  <div className="colRight">
                    <Input
                      className="form-control"
                      ref={editValueRefTwo}
                      variant="filled"
                      size="lg"
                      placeholder={"Value"}
                      width="auto"
                    />
                  </div>
                </div>
              </div>
              <div className="formGroup">
                <div className="rowBlock">
                  <label className="colLeft">
                    {isEvening ? columnsData[9].Header : columnsData[7].Header}
                  </label>
                  <div className="colRight">
                    <Input
                      className="form-control"
                      ref={editValueRefThree}
                      variant="filled"
                      size="lg"
                      placeholder={"Value"}
                      width="auto"
                    />
                  </div>
                </div>
              </div>
              <div className="formGroup textAlignRight">
                <Button
                  colorScheme="blue"
                  mr={3}
                  onClick={() => {
                    onCloseEdit(true);
                    setHighlightEditingRow(null);
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </Window>
      )}
    </Card>
  );
}
